import { z } from "zod";
import { ApiBase, HttpMethod } from "../../core/api-base";
import { GetDashboardStats200Response } from "../../api/generated/dashboard.zod";
import type { DashboardGranularity } from "./dashboard-form";

export type DashboardStatsResponse = z.infer<typeof GetDashboardStats200Response>;
export type DashboardStats = NonNullable<DashboardStatsResponse["data"]>;

export class DashboardApi extends ApiBase {
    public async fetchStats(granularity: DashboardGranularity): Promise<DashboardStats> {
        const response = await super.apiRequest(
            `/api/v1/admin/dashboard?granularity=${encodeURIComponent(granularity)}`,
            HttpMethod.Get,
            null,
            { noSpinner: true },
        );

        if (!response.ok) {
            throw new Error(`Dashboard stats request failed with status ${response.status}`);
        }

        const body = (await response.json()) as DashboardStatsResponse;
        if (!body.data) {
            throw new Error("Dashboard stats response had no data");
        }

        return body.data;
    }
}
